app.controller('CommonLaunchModalOrderSubmittedController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    $scope.openOrder = function (orderID) {

        if (!orderID) {
            return;
        }

        $rootScope.service.order.requestOrder(orderID, function (success, order) {
            if (order) {
                $bootstrapModal.open({
                    templateUrl: 'CommonModalOrderSubmitted.html',
                    controller: 'CommonModalSimpleController',
                    //size: 'lg',
                    resolve: {
                        items: {
                            order: order
                        }
                    }
                });
            }
        });
    };

}]);